import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IconComponent } from '../icons/icon-reusable';
import { AlertCircleIcon } from '../icons/icon';
import { ButtonComponent } from '../button-reusable/button-reusable';
import type { IconDef } from '../icons/icon';

@Component({
  selector: 'app-delete-popup',
  standalone: true,
  imports: [IconComponent, ButtonComponent],
  templateUrl: './delete-popup.html',
})
export class DeletePopupComponent {
  @Input() visible = false;
  @Input() header = 'Confirm Deletion';
  @Input() title = 'Remove this Picture?';
  @Input() message = 'This action is permanent and cannot be undone.';

  @Input() cancelText = 'Cancel';
  @Input() confirmText = 'Remove';
  @Input() icon: IconDef = AlertCircleIcon;

  @Output() cancel = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();

  onCancel() {
    this.cancel.emit();
  }

  onConfirm() {
    this.confirm.emit();
  }
}
